import React, { Component } from "react";
import TableReact from "../../../Components/TableReact";
import ImportarConflictoInteresesDataService from "../../../Services/Catalogo/ImportarConflictoIntereses.Service";
import { Constantes, ResolutionNames } from "../../../Constants/Constantes.js"
import UtilsDataService from "../../../Services/General/Utils.Service";
import BuscadorPersona from '../../../Components/BuscadorPersona';
import FileInput from '../../../Components/FileInput';
import Spinner from "../../../Components/Spinner";
import AuthLogin from "../../../Utils/AuthLogin";
import { ModuloPermiso } from "../../../Permisos/ModuloPermiso";
import ValidarPermiso from "../../../Permisos/ValidarPermiso";

const auth = new AuthLogin();

class ImportarConflictoIntereses extends Component {
    constructor(props){
        super(props);
        const idCuatrienio = this.props.match.params.idCuatrienio === undefined ? 0 : this.props.match.params.idCuatrienio;
        const idCorporacion = this.props.match.params.idCorporacion === undefined ? 0 : this.props.match.params.idCorporacion;
        this.state = {
            loading: false,
            idCorporacion: Number(idCorporacion),
            idCuatrienio: Number(idCuatrienio),
            corporacion: {
                id: 0,
                nombre: ""
            },
            cuatrienio: {
                id: 0,
                nombre: ""
            },
            excel: {
                file: null,
                idCuatrienio: idCuatrienio,
                idCorporacion: idCorporacion,
                arrayColumns: [],
                congresistas_encontrados: [],
                congresistas_no_encontrados: [],
                congresistas_todos: []
            },
            buscadorPersona: {
                data: [],
                selected: {id: 0},
                imgOrigin: auth.pathApi(),
                search: "",
                page: 1,
                rows: 15,
                totalRows: 0
            },
            personaModalIndex: 0
        }
    }

    async paginationPersona(page, rows, search) {
        let buscadorPersona = this.state.buscadorPersona;
        buscadorPersona.page = page;
        buscadorPersona.rows = rows;
        buscadorPersona.search = search;
        this.setState({ buscadorPersona: buscadorPersona });
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(
            async function () {
                await this.getAllPersonas(
                    1,
                    page,
                    rows,
                    search
                );
            }.bind(this),
            1000
        );
    }

    getAllPersonas = async (idFilterActive, corporacion, cuatrienio, page, rows, search) => {
        this.setState({ loading: true });
        let tableInfo = this.state.buscadorPersona;
        await ImportarConflictoInteresesDataService.getAllPersonasEnCorpCuatrienio({
            idFilterActive,
            corporacion,
            cuatrienio,
            search,
            page,
            rows
        }).then((response) => {
            tableInfo.data = response.data;
        })
        .catch((e) => {
            console.log(e);
        });

        await ImportarConflictoInteresesDataService.totalrecordsPersonasEnCorpCuatrienio({idFilterActive, corporacion, cuatrienio, search})
            .then((response) => {
                tableInfo.totalRows = response.data;
            })
            .catch((e) => {
                console.log(e);
            });
        this.setState(prevState => ({
            ...prevState,
            buscadorPersona: {
                ...prevState.buscadorPersona,
                data: tableInfo.data,
                totalRows: tableInfo.totalRows
            },
            loading: false
        }));
    };

    handlerChangeSearchForPersona = (value) =>{
        let buscadorPersona = this.state.buscadorPersona;
        buscadorPersona.search = value;
        this.setState({buscadorPersona})
    }

    handlerSelectPersona = (persona) =>{ // solo modificamos la id para cuando seleciconemos, asignarlo al índice que corresponde
        let buscadorPersona = this.state.buscadorPersona;
        let index = buscadorPersona.selected.index;
        buscadorPersona.selected = persona;
        buscadorPersona.selected.index = index;
        this.setState({buscadorPersona})
    }

    openModal = async (id, index) => { // al abrir modal se guardan id e índice del registro
        this.setState({loading: true, personaModalIndex: index})
        let buscadorPersona = this.state.buscadorPersona;
        if(id !== 0){
            await ImportarConflictoInteresesDataService.getPersonaByCongresistaDetalleId(id).then(response => {
                buscadorPersona.selected = response.data
            })
        }else{
            buscadorPersona.selected = {id: 0};
        }
        this.setState({loading: false, buscadorPersona: buscadorPersona})
    }

    handlerSavePersona = async () => {
        let buscadorPersona = this.state.buscadorPersona;
        let congresistas_todos = this.state.excel.congresistas_todos;
        console.log(buscadorPersona.selected)
        congresistas_todos[this.state.personaModalIndex].id = buscadorPersona.selected.congresista_detalle_id;
        this.setState(prevState => ({
            ...prevState,
            excel: {
                ...prevState.excel,
                congresistas_todos: congresistas_todos
            }
        }))
    }

    handlerChangeFile = async (e) => {
        let file = e.target.files[0];
        this.setState(prevState=>({
            ...prevState,
            loading: true,
            excel: {
                ...prevState.excel,
                file: file
            }
        }));
        await this.getDataExcel(file)
    }

    async componentDidMount() {
        await this.getCorporacion(this.state.idCorporacion);
        await this.getCuatrienio(this.state.idCuatrienio);
        await this.getAllPersonas(1, this.state.idCorporacion, this.state.idCuatrienio, this.state.buscadorPersona.page, this.state.buscadorPersona.rows, this.state.buscadorPersona.search);
    }

    getCorporacion = async (id) => {
        await UtilsDataService.getComboCorporacion().then(response => {
            let selected = response.data.filter((item) => {return item.id === id})[0];
            this.setState({corporacion: selected})
        });
    }

    getCuatrienio = async (id) => {
        await UtilsDataService.getComboCuatrienio().then(response => {
            let selected = response.data.filter((item) => {return item.id === id})[0];
            this.setState({cuatrienio: selected})
        })
    }

    getDataExcel = async (file = null) => {

        this.setState({loading: true});

        let data = this.state.excel;
        data.file = file !== null ? file : this.state.excel.file;
        data.congresistas_encontrados = [];
        data.congresistas_no_encontrados = [];

        await ImportarConflictoInteresesDataService.excel(data)
            .then((response) => {
                let congresistas_encontrados = response.data.congresistas_encontrados
                    ? response.data.congresistas_encontrados
                    : [];
                let congresistas_no_encontrados = response.data.congresistas_no_encontrados
                    ?  response.data.congresistas_no_encontrados
                    : [];

                let totalColumns = Math.ceil((congresistas_encontrados.length + congresistas_no_encontrados.length) / 20); // dividimos entre 20 para tener data de 20 en 20

                let arrayColumns = [];
                for (let i = 1; i <= totalColumns; i++) {
                    arrayColumns.push(i)
                }

                this.setState(prevState => ({
                    ...prevState,
                    excel: {
                        ...prevState.excel,
                        congresistas_encontrados: congresistas_encontrados,
                        congresistas_no_encontrados: congresistas_no_encontrados,
                        congresistas_todos: congresistas_encontrados.concat(congresistas_no_encontrados),
                        arrayColumns: arrayColumns
                    }
                }))
            })
            .catch(function (error) {
                console.log(error)
                this.setState({loading: false});
            });

        this.setState({loading: false})
    };

    handlerOnClickImportacion = async() => {
        let excel = this.state.excel;
        let congresistas_importar = excel.congresistas_todos.filter(item => item.id !== 0);

        let importacion = {
            file: excel.file,
            idCuatrienio: excel.idCuatrienio,
            idCorporacion: excel.idCorporacion,
            congresistas_importar: congresistas_importar,
            user : auth.username(),
        }

        await ImportarConflictoInteresesDataService.importacion(importacion)
            .then((response) => {
                console.log(response.data)
            })
            .catch(function (error) {
                console.log(error)
            });
    }

    render(){
        return (
            <div>
                <Spinner show={this.state.loading} />

                <ul className="breadcrumb push-down-0">
                    <li>Catálogos</li>
                    <li>Congresistas</li>
                    <li>Listado de congresistas por cuatrienio</li>
                    <li>Importar conflictos de interés</li>
                </ul>
                <div className="content-frame">
                    <div className="content-frame-top">
                        <div className="rowListado">
                            <div className="panel panel-default ">
                                <div className="panel-heading">
                                    <h3 className="panel-title"><span className="fas fa-file-import"/> Importar conflictos de interés en cuatrienio {this.state.cuatrienio.nombre} | {this.state.corporacion.nombre} </h3>
                                    <ul className="panel-controls">
                                        <li>
                                            <div style={{ minWidth: "150px" }}>
                                                <button
                                                    type="button"
                                                    className="btn btn-success"
                                                    onClick={this.handlerOnClickImportacion}
                                                >
                                                    <i className="fas fa-check-circle"/> Comenzar importación
                                                </button>
                                            </div>
                                        </li>
                                        <li>
                                            <div style={{ minWidth: "150px" }}>
                                                <FileInput buttonText={"Elegir archivo"} buttonStyle={{width: "100%", borderRadius: "5px"}} accept={"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"} handlerChangeFile={this.handlerChangeFile} showInput={false}/>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="panel-body">
                                    {
                                        this.state.excel.file !== null ?
                                        <h3 className="panel-title"><i className="fas fa-file-excel"></i> {this.state.excel.file.name}</h3>
                                        : ""
                                    }
                                    <div style={{clear: "both"}}></div>
                                    <div className="three-columns">
                                        {
                                            !this.state.loading ?
                                            this.state.excel.arrayColumns.map((value, a) => {
                                                let congresistas_todos = this.state.excel.congresistas_todos;
                                                let dataColumn = congresistas_todos.slice(a * 20, ((a + 1) * 20));

                                                return (
                                                    <div className="conflictoColumn">
                                                        <div className="conflictoHeader">
                                                            <div className="nombre">Nombre completo</div>
                                                            <div className="search"><i className="fas fa-search"></i></div>
                                                            <div className="verif">SI/NO</div>
                                                        </div>
                                                        <div className="conflictoBody">
                                                            {
                                                                dataColumn.map((congresista, index) => {
                                                                    let itemIndex = index;
                                                                    if(a > 0)
                                                                        itemIndex = index + (a*20)

                                                                    return (
                                                                        <div className="conflictoRow">
                                                                            <div className="nombre"><input readOnly={true} type="text" value={congresista.nombre_completo} /></div>
                                                                            <div className="search"><button data-toggle="modal" data-target="#select-persona" onClick={()=>{this.openModal(congresista.id, itemIndex)}} type="button" className="btn btn-primary"><i className="fas fa-search"></i></button></div>
                                                                            <div className="verif"><i className={`fas ${congresista.id === 0 ? "fa-times" : "fa-check-circle"}`}></i></div>
                                                                        </div>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                );
                                            })
                                            : ""
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal footer-fixed" id="select-persona" tabIndex="-1" role="dialog" aria-labelledby="largeModalHead" aria-hidden="true">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" data-dismiss="modal">
                                        <span aria-hidden="true">&times;</span>
                                        <span className="sr-only">Cerrar</span>
                                    </button>
                                    <h4 className="modal-title" id="largeModalHead">
                                        <i className="fa fa-user"></i>{" "}
                                        Vincule a un congresista
                                    </h4>
                                </div>
                                <div className="modal-body">
                                    <BuscadorPersona handler={this.paginationPersona} handlerChangeSearch={this.handlerChangeSearchForPersona} handlerSelectPersona={this.handlerSelectPersona} data={this.state.buscadorPersona.data} imgDefault={Constantes.NoImagen} imgOrigin={this.state.buscadorPersona.imgOrigin} pageExtends={this.state.buscadorPersona.page} pageSize={this.state.buscadorPersona.rows} totalRows={this.state.buscadorPersona.totalRows} search={this.state.buscadorPersona.search} selected={this.state.buscadorPersona.selected} />
                                </div>
                                <div className="modal-footer">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <button type="button" className="btn btn-default pull-left" data-dismiss="modal">Cerrar</button>
                                            <button className="btn btn-primary pull-right" onClick={()=>{this.handlerSavePersona()}} data-dismiss="modal"><i className="fa fa-check"></i> Vincular</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        )
    }
}

export default ImportarConflictoIntereses;
